import React, { type Dispatch, type SetStateAction } from 'react';

import { ReactComponent as CubeIcon } from '@pkg/assets/icons/cube.svg';
import { ReactComponent as RefreshIcon } from '@pkg/assets/icons/refresh.svg';

import {
    InnerItem,
    Item,
    RadioButton,
    RadioButtonDesc,
    RadioButtonHeading,
    RadioButtonLabel,
    Wrapper,
} from './RadioGroup.style';

export enum Settings {
    auto = 'auto',
    manual = 'manual',
}

interface Props {
    selected: Settings;
    setSelected: Dispatch<SetStateAction<Settings>>;
}

export const RadioGroup = ({ selected, setSelected }: Props) => {
    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelected(value);
    };

    return (
        <Wrapper>
            <Item>
                <InnerItem>
                    <RadioButton
                        type="radio"
                        name="radio"
                        value={Settings.auto}
                        checked={selected === Settings.auto}
                        onChange={(event) => handleSelectChange(event)}
                    />
                    <RadioButtonLabel />
                    <RadioButtonHeading>
                        <RefreshIcon /> Auto
                    </RadioButtonHeading>
                    <RadioButtonDesc>
                        Once your wallet is connected, new collectibles will be automatically added to your profile.
                    </RadioButtonDesc>
                </InnerItem>
            </Item>

            <Item>
                <InnerItem>
                    <RadioButton
                        type="radio"
                        name="radio"
                        value={Settings.manual}
                        checked={selected === Settings.manual}
                        onChange={(event) => handleSelectChange(event)}
                    />
                    <RadioButtonLabel />
                    <RadioButtonHeading>
                        <CubeIcon /> Manual
                    </RadioButtonHeading>
                    <RadioButtonDesc>You will need to manually add new collectibles to your profile.</RadioButtonDesc>
                </InnerItem>
            </Item>
        </Wrapper>
    );
};
